export const HttpServiceConstants = {
  // Headers
  headers: {
    contentType: 'Content-Type',
    applicationJson: 'application/json',
  },

  // Default error messages
  messages: {
    requestFailed: 'Request failed',
  },

  // URL construction
  url: {
    requestParam: 'request',
  },

  // Axios responseType for file downloads
  responseTypes: {
    blob: 'blob',
  },

  // Data types for URL construction
  dataTypes: {
    number: 'number',
    string: 'string',
    boolean: 'boolean',
  },
} as const;
